import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const searchBuildBundleUrl = (endpoint) => `${API_ROUTES.TRANSFER.BASE}/${endpoint ? endpoint : ""}`

export const transferService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransLocations: builder.query({
      query: () => ({
        url: searchBuildBundleUrl("locations"),
        method: "GET",
      }),
    }),
    searchTransLocations: builder.query({
      query: (params) => ({
        url: searchBuildBundleUrl("locations/search"),
        method: "GET",
        params,
      }),
    }),
    getTransMeta: builder.query({
      query: (params) => ({
        url: searchBuildBundleUrl("meta"),
        method: "GET",
        params,
      }),
    }),
    // Поиск трансферов
    // params: { from_type, from_id, to_type, to_id, depart_from, depart_to?, return_from?, return_to? }
    searchTransfers: builder.query({
      query: (params) => ({
        url: searchBuildBundleUrl("search-transfers"),
        method: "GET",
        params,
      }),
    }),

    getTransLocationsFrom: builder.query({
      query: (params = {}) => ({
        url: searchBuildBundleUrl("locations"),
        method: "GET",
        params: { field: "from", ...params },
      }),
    }),

    getTransLocationsTo: builder.query({
      query: (params = {}) => ({
        url: searchBuildBundleUrl("locations"),
        method: "GET",
        params: { field: "to", ...params },
      }),
    }),

    searchTransLocationsFrom: builder.query({
      query: ({ q } = {}) => ({
        url: searchBuildBundleUrl("locations/search"),
        method: "GET",
        params: { field: "from", q },
      }),
    }),

    searchTransLocationsTo: builder.query({
      query: ({ q, from_type, from_id } = {}) => ({
        url: searchBuildBundleUrl("locations/search"),
        method: "GET",
        params: { field: "to", q, from_type, from_id },
      }),
    }),
    transPrepareBooking: builder.mutation({
      query: (body) => ({
        url: searchBuildBundleUrl("prepare_booking"),
        method: "POST",
        body,
      }),
    }),
    getTransferDates: builder.query({
      query: ({
        from_type,
        from_id,
        to_type,
        to_id,
        adults,
        children,
        infants,
        year,
        month,
        currency,
      }) => ({
        url: searchBuildBundleUrl("available_dates"),
        params: {
          from_type,
          from_id,
          to_type,
          to_id,
          adults,
          children,
          infants,
          year,
          month,
          currency,
        },
      }),
    }),
  }),
})

export const {
  useGetTransLocationsQuery,
  useLazyGetTransLocationsQuery,
  useLazySearchTransLocationsQuery,
  useGetTransMetaQuery,
  useSearchTransLocationsQuery,
  useLazySearchTransfersQuery,
  useGetTransLocationsFromQuery,
  useLazyGetTransLocationsFromQuery,
  useGetTransLocationsToQuery,
  useLazyGetTransLocationsToQuery,
  useLazySearchTransLocationsFromQuery,
  useLazySearchTransLocationsToQuery,
  useTransPrepareBookingMutation,
  useLazyGetTransferDatesQuery,
} = transferService
